import React, { useState } from 'react';
import style from '../css/ResultadosAlumnos2.module.css';

import VideoModal from './modals/VideoModal';

import ref1 from '../images/resultados-alumnos/ref1.png';
import ref2 from '../images/resultados-alumnos/ref2.png';
import ref3 from '../images/resultados-alumnos/ref3.png';
import ref4 from '../images/resultados-alumnos/ref4.png';
// import play from '../images//play.png';

import { BsArrowRight } from 'react-icons/bs';

const ResultadosAlumnos2 = () => {
	const [openModal, setOpenModal] = useState(false);
	const [url, setUrl] = useState(false);

	const handlerClose = () => {
		setOpenModal(false);
	};

	const handlerOpen = (url) => {
		setUrl(url);
		setOpenModal(true);
	};

	return (
		<section className={style.mainSection}>
			<VideoModal modal={openModal} url={url} handlerClose={handlerClose} />
			<div className={style.titleContainer}>
				<h1>
					Resultados de Alumnos <br />
					<span>
						{' '}
						formamos <b>especialistas 3D.</b>{' '}
						{/* <img
							src='https://writebot-html.themetags.net/assets/img/text-underline-1.svg'
							alt='line'
						/> */}
					</span>
				</h1>
				{/* <p>
					Atrévete a marcar la diferencia, estás a solo un paso de convertirte en un especialista
					3D. Aquí te mostramos algunos de los resultados de nuestros alumnos.
				</p> */}
			</div>
			<div className={style.mainContainer}>
				<div className={style.container1}>
					<div style={{ position: 'relative' }}>
						<img src={ref1} alt='ref1' />

						{/* <div
							className={`${style.playButton} ${style.playButtonPosition1}`}
							onClick={() => handlerOpen('https://www.youtube.com/watch?v=GtU1POv0HSc')}
						>
							<img src={play} alt='play' />
						</div> */}
					</div>

					<p>
						Nuestros entrenamientos están diseñados para ofrecer a nuestros estudiantes una
						formación completa y actualizada, con las últimas herramientas y tecnologías del
						mercado.
						<span> ¡No necesitas ser un experto para iniciar!</span>
					</p>
					<div>
						<a
							className={style.button1}
							href='#plans'
							// target='blank_'
						>
							<span>Inscríbete Ahora</span>
							<BsArrowRight />{' '}
						</a>
						<h2>
							{' '}
							<span> Aprende 3D </span> de 0 a 100
						</h2>
					</div>
				</div>
				<div className={style.container2}>
					<div>
						<div className={style.containerImg}>
							<img src={ref2} alt='ref2' />
							{/* <div
								className={`${style.playButton} ${style.playButtonPosition1}`}
								onClick={() => handlerOpen('https://www.youtube.com/watch?v=aDZl5VrPBvw')}
							>
								<img src={play} alt='play' />
							</div> */}
						</div>

						<div className={style.containerImg}>
							<img src={ref3} alt='ref3' />
							{/* <div
								className={`${style.playButton} ${style.playButtonPosition1}`}
								onClick={() => handlerOpen('https://www.youtube.com/watch?v=ubQcdzxIWIY')}
							>
								<img src={play} alt='play' />
							</div> */}
						</div>
					</div>

					<div style={{ position: 'relative' }}>
						<img src={ref4} alt='ref4' />

						{/* <div
							className={`${style.playButton} ${style.playButtonPosition1}`}
							onClick={() => handlerOpen('https://www.youtube.com/watch?v=xmZPVoRM3cA')}
						>
							<img src={play} alt='play' />
						</div> */}
					</div>
				</div>
			</div>
			{/* <h2 className={style.lastTitle}>
				Hemos formado más de<span> 25,000 alumnos exitosos</span>{' '}
			</h2> */}
		</section>
	);
};

export default ResultadosAlumnos2;
